export const translations = {
  es: {
    nav: {
      item1: "Despegue",
      item2: "Aterrizaje",
      item3: "Contacto",
    },
    hero: {
      title: "Fase 1: DESPEGUE",
    },
    section2: {
      text: "¿Existe un hábito que se pueda crear rápidamente, fácilmente y sin esfuerzo, y que al mismo tiempo sea tan poderoso que inmediatamente empiece a mejorar todos los aspectos de nuestra vida?",
    },
    section3: {
      titleYellow: "DESPEGUE es ese primer nuevo hábito que vas a crear.",
      paragraph1:
        "Una vez creado, este nuevo hábito causará un efecto psicológico poderoso en ti, elevará tu autoconfianza y llevará a la creación del segundo nuevo hábito.",
      paragraph2:
        "Este segundo nuevo hábito llevará a la creación de otro nuevo hábito y ese nuevo hábito a otro …",
      subtextBlue:
        "Todos estos nuevos pequeños hábitos juntos, junto con un material especial que te proporcionaremos, te llevará a REPROGRAMAR tu mente.\n\nY ese es el momento que los límites desaparecen de tu vida y todo comienza a cambiar a  mejor.\n\nEn ese momento empieza tu DESPEGUE hacia el sueño que tienes en el corazón.\n\n¡ Abróchate el cinturón !",
    },
    section4: {
      titleYellow:
        "¿Por qué creemos que DESPEGUE debería ser tu primer nuevo hábito?",
      points: [
        "Se crea rápido y sin esfuerzo.",
        "El impacto que tiene en tu cuerpo, en la naturaleza y en tu cerebro es poderoso e inmediato. Este triple efecto lo hemos llamado el Círculo de esperanza.",
      ],
      circle: {
        title: "Círculo de esperanza",
        items: [
          "Nutrientes para cuerpo",
          "Nutrientes para naturaleza",
          "Nutrientes para mente",
        ],
      },
    },
    section5: {
      title: "Nutrientes para el cuerpo",
    },
    section6: {
      titleYellow:
        "Despegue es mezcla de 4 variedades de las microverduras que contienen mas nutrientes del mundo:",
      microgreens: {
        topLeft: "Micro Brócoli",
        topRight: "Micro Rábano Venom",
        bottomLeft: "Micro Col lombarda",
        bottomRight: "Micro Rábano Daikón",
      },
    },
    section7: {
      titleYellow: "Que son las microverduras?",
      paragraphs: [
        'Las microverduras son los "bebes" de las hortalizas.',
        "Se trata de la fase en la vida de las hortalizas cuando tienen entre 7 y 21 días y miden unos pocos centímetros de altura.",
        "En esta fase el contenido de los nutrientes está concentrado.",
        "Según el estudio del Departamento de Agricultura de la Universidad de Maryland, EE.UU. ,",
        "las microverduras contienen de 4 a 40 veces más nutrientes que las hortalizas adultas.",
      ],
    },
    section8: {
      titleYellow:
        "Comparación de 100g de las microverduras con 100g de las verduras adultas:",
      paragraphs: [
        "Micro Brócoli contiene 40 veces más nutrientes que el brócoli adulto que compras en los mercados y fruterías.",
        "Micro Rábano contiene 19 veces más nutrientes que rábano adulto.",
        "Micro Col Lombarda contiene 260 veces más carotenoides que la col lombarda adulta y mas vitamina C que la naranja.",
      ],
    },
    section9: {
      textLeft: [
        "Las microverduras se cultivan en el interior, en condiciones controladas.",
        "Humedad, temperatura y flujo del aire se controlan 24/7.",
        "Se cultivan verticalmente en estanterías.",
        "Crecen en macetas, bajo lámparas LED especiales. Las características técnicas de las lámparas LED se ajustan según el proceso de la fotosíntesis de cada variedad.",
        "¿Sabias que el personal de la Estación Espacial Internacional cultiva y come  microverduras en el espacio?  Una pequeña cantidad de microverduras cubre sus requisitos nutricionales diarios.",
      ],
    },
    section10: {
      title: "Rapidez y simplicidad",
      paragraphs: [
        "Las microverduras contienen de 4 a 40 veces mas nutrientes que las hortalizas adultas.",
        'Por lo tanto, lo único que debes hacer es tirar un pequeño "ramillete" de microverduras en tus platos favoritos.',
        "De ese modo cubres los requisitos nutricionales diarios de tu cuerpo: simple y rápido.",
      ],
      effectTitle: "Efecto inmediato",
      effectText: [
        "Podríamos hacer una lista larga de los beneficios de las microverduras. Pero no lo haremos. Preferimos que los notes.",
        "Queremos que sientas los efectos …",
        'Te "revelamos" solo uno, que nos comentan todos los nuevos clientes: mejora la digestión.',
      ],
    },
    section11: {
      title: "Comienza la nueva realidad …Mejor realidad.",
      paragraphs: [
        "¡Sin químicos ni pesticidas!",
        "En el proceso del cultivo de las microverduras se utiliza solamente agua potable purificada.",
        "Se utiliza 80% menos de agua y 90% menos de tierra fértil que en los cultivos tradicionales.",
        "Tu propio jardinero: No hay intermediarios.",
        "La misma persona lo cultiva para ti y te trae el producto.",
        "Sabrás a que hora llega tu pedido, para que lo tengas fresco.",
        "¡Te enviaremos fotos para que veas como crecen las microverduras que has pedido!",
      ],
    },
    section12: {
      title: "Nutrientes para naturaleza",
    },
    section13: {
      title: "¿Sabes que es la  Alfombra mágica?",
    },
    section14: {
      title: "Tu contribución a la magia",
      text: "Cada vez cuando se termina la preparación de tu pedido, la alfombra mágica se saca de la maceta…",
    },
    section15: {
      paragraphs: [
        "Los restos orgánicos se devuelven a la naturaleza.",
        "La tierra y las plantas se abonan con los nutrientes de la alfombra mágica y los animales se nutren con el resto de las microverduras.",
      ],
    },
    section16: {
      title: "¿Sabías que nuestras microverduras crecen con música clásica?",
    },
    section17: {
      paragraphs: [
        'Las microverduras que comes "escuchan" la música de Mozart, Bach, Beethoven…',
        "Por las vibraciones que emiten sus composiciones crecen mejor.",
        "¿Pero sabes que impacto tiene la música clásica en el cerebro humano, particularmente en el de los niños?",
        "La vibración de la música clásica relaja y mejora el funcionamiento de una sección del cerebro que coordina los hemisferios izquierdo y derecho.",
        'Esta información es solo una "gota en el mar" de material que hemos preparado para nuestros clientes regulares…',
        "Y  es la  introducción a la segunda fase del proyecto:",
      ],
    },
    section18: {
      title: "Fase 2: Aterrizaje",
    },
    section19: {
      title: "Nutrientes para mente",
    },
    section20: {
      paragraphs: [
        "En solo un par de semanas habrás conseguido crear un nuevo hábito:",
        "Tu y las personas mas importantes de tu vida cada día consumís Despegue- la mezcla con más nutrientes del mundo.",
        "Aparte de consumir los ingredientes con mas nutrientes del mundo, sabéis de donde vienen y quien los cultiva para vosotros (¡SIN ningún químico, y CON mucho cariño!) . También sabéis que una parte de esos ingredientes se devuelven a la naturaleza.",
        "¿Sabías que sólo el 5% de las personas del mundo conscientemente toman la decisión de crear el nuevo hábito que mejorará su vida?",
        "¡Felicidades!",
        '¡ Bienvenida/o al "5% CLUB" !',
      ],
    },
    section21: {
      paragraphs: [
        "Ahora es importante que hagas 2 cosas:",
        "1. Celebra con tus seres queridos esta victoria (esto es muy importante y tiene un impacto enorme a una sección de tu mente).",
        "2. Cuando termines la celebración, decide- cual es el segundo nuevo pequeño hábito que vas a crear. Tu eliges.",
        'Has conseguido preparar el "ambiente mental" por lo que viene…',
        "¿ Te acuerdas, en el principio de esta página web, de único párrafo con las letras azules ?",
      ],
    },
    section22: {
      yellowText: [
        "Ahora, en el momento cuando tu salud general se mejora, tu autoconfianza sube y en tu cerebro se inicia algo grande, te enviaremos el material que:",
        "1. Despertará <span class='em'><strong>el genio</strong></span> que ya tienes dentro [aunque quizás de momento no estás consciente de ello]",
        "2. Elevará tu <strong>nivel de conciencia</strong>",
        "3. Activará <span class='em'><strong>el mecanismo creativo</strong></span> de la fuerza más potente de la naturaleza: TU MENTE.",
      ],
      whiteText: [
        "Y ese es el momento cuando todo lo que has deseado desde siempre se convierte en realidad.",
        "Es el momento de tu ATERRIZAJE en el sueño que tienes en corazón.",
        "Desabróchate el cinturón…",
      ],
    },
  },
  ca: {
    nav: {
      item1: "Enlairament",
      item2: "Aterratge",
      item3: "Contacte",
    },
    hero: {
      title: "Fase 1: ENLAIRAMENT",
    },
    section2: {
      text: "Existeix un hàbit que es pugui crear ràpidament, fàcilment i sense esforç, i que al mateix temps sigui tan poderós que immediatament comenci a millorar tots els aspectes de la nostra vida?",
    },
    section3: {
      titleYellow: "ENLAIRAMENT és aquell primer nou hàbit que crearàs.",
      paragraph1:
        "Un cop creat, aquest nou hàbit causarà un efecte psicològic poderós en tu,elevarà la teva autoconfiança i et portarà a la creació del segon nou hàbit.",
      paragraph2:
        "Aquest segon nou hàbit et portarà a la creació d’un altre nou hàbit, i aquest nou hàbit a un altre…",
      subtextBlue:
        "Tots aquests nous petits hàbits junts, juntament amb un material especialque et proporcionarem, et portaran a REPROGRAMAR la teva ment.\n\nI és en aquest moment quan els límits desapareixen de la teva vida i tot comença a canviar a millor.En aquest moment comença el teu ENLAIRAMENT cap al somni que tens al cor.\n\n¡ Corda’t el cinturó !",
    },
    section4: {
      titleYellow:
        "Per què creiem que ENLAIRAMENT hauria de ser el teu primer nou hàbit?",
      points: [
        "Es crea ràpid i sense esforç.",
        "L’impacte que té en el teu cos, en la natura i en el teu cervell és poderós i immediat. Aquest triple efecte l’hem anomenat el Cercle d’esperança.",
      ],
      circle: {
        title: "Cercle d'esperança",
        items: [
          "Nutrients per al cos",
          "Nutrients per a la naturalesa",
          "Nutrients per a la ment",
        ],
      },
    },
    section5: {
      title: "Nutrients per al cos",
    },
    section6: {
      titleYellow:
        "Enlairament és una mescla de 4 varietats de microverdures que contenen més nutrients del món:",
      microgreens: {
        topLeft: "Micro Bròquil",
        topRight: "Micro Rave Venom",
        bottomLeft: "Micro Col llombarda",
        bottomRight: "Micro Rave Daikón",
      },
    },
    section7: {
      titleYellow: "Què són les microverdures?",
      paragraphs: [
        "Les microverdures són els “nadons” de les hortalisses.",
        "Es tracta de la fase en la vida de les hortalisses en què tenen entre 7 i 21 dies i mesuren només uns pocs centímetres d’alçada.",
        "En aquesta fase, el contingut de nutrients està concentrat.",
        "Segons l’estudi del Departament d’Agricultura de la Universitat de Maryland, als Estats Units,",
        "les microverdures contenen entre 4 i 40 vegades més nutrients que les hortalisses adultes.",
      ],
    },
    section8: {
      titleYellow:
        "Comparació de 100 g de microverdures amb 100 g de verdures adultes:",
      paragraphs: [
        "Microbròquil conté 40 vegades més nutrients que el bròquil adult que compres als mercats i fruiteries.",
        "Microrave conté 19 vegades més nutrients que el rave adult",
        "Micro col llombarda conté 260 vegades més carotenoides que la col llombarda adulta i més vitamina C que la taronja.",
      ],
    },
    section9: {
      textLeft: [
        "Les microverdures es cultiven en interior, en condicions controlades.",
        "La humitat, la temperatura i el flux d’aire es controlen les 24 hores del dia, 7 dies a la setmana.",
        "Es cultiven verticalment en prestatgeries.",
        "Creixen en testos, sota làmpades LED especials. Les característiques tècniquesd’aquestes làmpades LED s’ajusten segons el procés de fotosíntesi de cada varietat.",
        "Sabies que el personal de l’Estació Espacial Internacional cultiva i menja microverdures a l’espai? Una petita quantitat de microverdures cobreix els seus requisits nutricionals diaris.",
      ],
    },
    section10: {
      title: "Rapidesa i simplicitat",
      paragraphs: [
        "Les microverdures contenen de 4 a 40 vegades més nutrients que les hortalisses adultes",
        "Per tant, l’únic que has de fer és afegir un petit grapat de microverdures als teus plats preferits.",
        "D’aquesta manera, cobreixes els requisits nutricionals diaris del teu cos: simple i ràpid.",
      ],
      effectTitle: "Efecte immediat",
      effectText: [
        "Podríem fer una llarga llista dels beneficis de les microverdures. Però no ho farem. Preferim que els notis.",
        "Volem que sentis els efectes…",
        "Només t’avançarem un, el que ens comenten tots els nous clients: millora la digestió.",
      ],
    },
    section11: {
      title: "Comença la nova realitat… Una realitat millor.",
      paragraphs: [
        "Sense químics ni pesticides!",
        "En el procés de cultiu de les microverdures s’utilitza només aigua potable purificada.",
        "S’utilitza un 80% menys d’aigua i un 90% menys de terra fèrtilque en els cultius tradicionals.",
        "El teu propi jardiner: no hi ha intermediaris.",
        "La mateixa persona les cultiva per a tu i t’entrega el producte.",
        "Sabràs a quina hora arriba la teva comanda, perquè la tinguis ben fresca.",
        "T’enviarem fotos perquè puguis veure com creixen les microverdures que has demanat!",
      ],
    },
    section12: {
      title: "Nutrients per a la natura",
    },
    section13: {
      title: "Saps què és la  Catifa màgica?",
    },
    section14: {
      title: "La teva contribució a la màgia",
      text: "Cada vegada que s’acaba la preparació de la teva comanda, la catifa màgica es treu del test…",
    },
    section15: {
      paragraphs: [
        "Els residus orgànics es tornen a la natura.",
        "La terra i les plantes s’adoben amb els nutrients de la catifa màgica, i els animals s’alimenten de la resta de les microverdures.",
      ],
    },
    section16: {
      title:
        "Sabies que les nostres microverdures creixen amb música clàssica?",
    },
    section17: {
      paragraphs: [
        "Les microverdures que menges “escolten” la música de Mozart, Bach, Beethoven…",
        "Per les vibracions que emeten les seves composicions creixen millor.",
        "Però saps quin impacte té la música clàssica en el cervell humà, particularment en el dels infants?",
        "La vibració de la música clàssica relaxa i millora el funcionamentd’una part del cervell que coordina els hemisferis esquerre i dret.",
        "Aquesta informació és només una gota d’aigua en tot el mar de material que hem preparat per als nostres clients habituals…",
        "I és la introducció a la segona fase del projecte:",
      ],
    },
    section18: {
      title: "Fase 2: Aterratge",
    },
    section19: {
      title: "Nutrients per a la ment",
    },
    section20: {
      paragraphs: [
        "En només un parell de setmanes hauràs aconseguit crear un nou hàbit:",
        "Tu i les persones més importants de la teva vida consumiu cada dia Enlairament, la mescla amb més nutrients del món.",
        "A més de consumir els ingredients amb més nutrients del món, sabeu d’on provenen i qui els cultiva per a vosaltres (SENSE cap químic i AMB molt d’afecte!). També sabeu que una part d’aquests ingredients es retorna a la natura.",
        "Sabies que només el 5% de les persones del món prenen conscientment la decisió de crear l’hàbit nou que millorarà la seva vida?",
        "Felicitats!",
        "Et donem la Benvinguda al 5% CLUB !",
      ],
    },
    section21: {
      paragraphs: [
        "Ara és important que facis dues coses:",
        "1. Celebra amb els teus éssers estimats aquesta victòria (això és molt important i té un impacte enorme en una part de la teva ment).",
        "2. Quan acabis la celebració, decideix quin serà el segon petit hàbit nou que crearàs. Tu ho tries.",
        "Has aconseguit preparar “l’ambient mental” per al que vindrà…",
        "T’en recordes, al principi d’aquesta pàgina web, del únic paràgraf  amb les lletres blaves?",
      ],
    },
    section22: {
      yellowText: [
        "Ara, en el moment en què la teva salut general millora, la teva autoconfiança puja i al teu cervell s'inicia alguna cosa gran, t'enviarem el material que:",
        "1. Despertarà <span class='em'><strong>el geni</strong></span> que ja tens dins (encara que potser ara mateix no n'ets conscient)",
        "2. Elevarà el teu <strong>nivell de consciència</strong>",
        "3. Activarà <span class='em'><strong>el mecanisme creatiu</strong></span> de la força més potent de la natura: LA TEVA MENT.",
      ],
      whiteText: [
        "I aquest és el moment en què tot allò que sempre has desitjat es converteix en realitat.",
        "És el moment del teu ATERRATGE en el somni que tens al cor.",
        "Descorda’t el cinturó...",
      ],
    },
  },
};
